import type { DetailedCountForViewApiResponse } from '@/api/generated/rest-v4-api';
import { classifyStatus } from '@/utils/schedule-records';

export interface StatusCounts {
  overdue: number;
  progress: number;
  completed: number;
  completedPercent: number;
}

export interface ProjectionSummary {
  planned: number;
  isStale: boolean;
}

// The counts come grouped by form, then by status caption; the grid's status rule regroups them.
export const summarizeDetailedCount = (result: DetailedCountForViewApiResponse['result']): StatusCounts => {
  const totals = { overdue: 0, progress: 0, completed: 0 };

  for (const statusCounts of Object.values(result ?? {})) {
    for (const entry of statusCounts) {
      for (const [status, count] of Object.entries(entry)) {
        totals[classifyStatus(status)] += count;
      }
    }
  }

  const total = totals.overdue + totals.progress + totals.completed;
  return { ...totals, completedPercent: total > 0 ? Math.floor((totals.completed / total) * 100) : 0 };
};

// The spec types this response as a loose map; `projectedCount` and `projections` are what the API sends.
export const summarizeProjection = (response: unknown): ProjectionSummary => {
  const record = typeof response === 'object' && response !== null ? (response as Record<string, unknown>) : {};
  const projections =
    typeof record.projections === 'object' && record.projections !== null
      ? (record.projections as Record<string, unknown>)
      : {};

  return {
    planned: typeof record.projectedCount === 'number' ? record.projectedCount : 0,
    isStale: projections.available !== true || projections.outdated === true,
  };
};
